var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPawCircle = function SvgPawCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#FFF2EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7616 44.5723C40.258 44.5723 28.2874 57.7181 28.2874 66.0214C28.1931 69.7605 31.058 71.9997 35.8835 71.9997C41.1119 71.9997 44.5725 69.3105 48.7616 69.3105C52.9935 69.3105 56.4648 71.9997 61.6396 71.9997C66.3644 71.9997 69.3257 69.7626 69.3257 66.0267C69.2357 57.7289 57.2684 44.5723 48.7616 44.5723Z",
    fill: "#FF7342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.9882 43.2226C31.8771 39.5135 28.4348 37.1029 25.3149 37.8528C22.195 38.6028 20.5704 42.2155 21.6818 45.9225C22.7929 49.6402 26.2352 52.0508 29.3551 51.3009C32.475 50.5509 34.0917 46.9296 32.9882 43.2226ZM42.0628 40.9941C45.3701 40.1236 47.0308 35.7336 45.7591 30.9906C44.4873 26.2476 40.7771 23.3731 37.4569 24.1477C34.1495 25.0182 32.4889 29.4082 33.7606 34.1512C35.0345 38.7978 38.7415 41.8727 42.0628 40.9941ZM72.2115 37.855C69.0917 37.2014 65.6493 39.5156 64.5383 43.2248C63.4273 46.935 65.0472 50.5498 68.1671 51.2998C71.2869 51.9533 74.7154 49.6391 75.8403 45.93C76.947 42.2155 75.2328 38.605 72.2115 37.855ZM55.4551 40.9941C58.68 41.8646 62.4855 38.7978 63.7572 34.1512C65.029 29.5046 63.3689 25.0177 60.061 24.1477C56.8361 23.2772 53.0305 26.344 51.7588 30.9906C50.4839 35.6372 52.1445 40.1263 55.4551 40.9941Z",
    fill: "#FF7342"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPawCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paw_circle.fb95d3e7.svg";
export { ForwardRef as ReactComponent };